/**
 * @file string.js
 * String utility helpers shared across feature modules.
 */

/**
 * Returns an empty string if the given value is undefined, otherwise returns the value as-is.
 * Used to safely read jQuery attribute results that may be undefined.
 *
 * @param {*} value The value to check.
 * @returns {*} The original value, or `""` if it was undefined.
 */
export function checkUndefined(value) {
    return typeof value === "undefined" ? "" : value;
}
